import { gql } from "lib/apolloClient";
import { courseFlowResourceFragment } from "./CourseFlowFragments";

export const createCourseFlowResourceMutation = gql`
  mutation createCourseFlowResource(
    $input: CreateLearningCourseFlowResourceInput!
    $assessmentAssignmentsFilters: AssessmentAssignmentsFilters
    $studentIds: [ID!]
    $skipAssignedStudents: Boolean! = true
    $stateFilters: LearningCourseFlowStateFilter
    $filters: LearningCourseFlowFilter
    $syncedBluePrintItemFilters: SyncedBluePrintItemFilter
  ) {
    planner {
      createLearningCourseFlowResource(input: $input) {
        ...courseFlowResource
      }
    }
  }
  ${courseFlowResourceFragment.completeDetails}
`;

export const deleteCourseFlowResourceMutation = gql`
  mutation deleteCourseFlowResource(
    $input: DeleteLearningCourseFlowResourceInput!
  ) {
    planner {
      deleteLearningCourseFlowResource(input: $input)
    }
  }
`;

export const updateCourseFlowResourceMutation = gql`
  mutation updateCourseFlowResource(
    $input: UpdateLearningCourseFlowResourceInput!
  ) {
    planner {
      updateLearningCourseFlowResource(input: $input) {
        id
      }
    }
  }
`;

export const reorderCourseFlowResourceMutation = gql`
  mutation reorderCourseFlowResource(
    $input: ReorderLearningCourseFlowResourceInput!
  ) {
    planner {
      reorderLearningCourseFlowResource(input: $input)
    }
  }
`;

export const repeatCourseFlowResourceMutation = gql`
  mutation repeatCourseFlowResource(
    $input: RepeatLearningCourseFlowResource!
    $assessmentAssignmentsFilters: AssessmentAssignmentsFilters
    $studentIds: [ID!]
    $skipAssignedStudents: Boolean! = true
    $stateFilters: LearningCourseFlowStateFilter
    $filters: LearningCourseFlowFilter
    $syncedBluePrintItemFilters: SyncedBluePrintItemFilter
  ) {
    planner {
      repeatLearningCourseFlowResource(input: $input) {
        isSuccess
        error
        courseFlowResource {
          ...courseFlowResource
        }
      }
    }
  }
  ${courseFlowResourceFragment.completeDetails}
`;

export const importCourseFlowResourceMutation = gql`
  mutation importCourseFlowResource(
    $input: ImportLearningCourseFlowResourceInput!
    $assessmentAssignmentsFilters: AssessmentAssignmentsFilters
    $studentIds: [ID!]
    $skipAssignedStudents: Boolean! = true
    $stateFilters: LearningCourseFlowStateFilter
    $filters: LearningCourseFlowFilter
    $syncedBluePrintItemFilters: SyncedBluePrintItemFilter
  ) {
    planner {
      importLearningCourseFlowResource(input: $input) {
        isSuccess
        error
        courseFlowResource {
          ...courseFlowResource
        }
      }
    }
  }
  ${courseFlowResourceFragment.completeDetails}
`;

export const shareCourseFlowResourceMutation = gql`
  mutation shareCourseFlowResource(
    $input: ShareLearningCourseFlowResourceInput!
  ) {
    planner {
      shareLearningCourseFlowResource(input: $input)
    }
  }
`;

export const updateUnitPlanSharingMutation = gql`
  mutation updateUnitPlanSharing($input: UnitPlanUpdateInput!) {
    planner {
      updateUnitPlan(input: $input) {
        id
      }
    }
  }
`;

export const updateLockedStateMutation = gql`
  mutation updateLockedState($input: LearningCourseEntityLockUpdateInput!) {
    planner {
      bulkUpdateLearningCourseEntityLock(input: $input) {
        isSuccess
      }
    }
  }
`;
